import { v4 } from 'uuid'
import { DEFAULT_SLAB_LIKE_SETTINGS } from '@editor/pages/StructuralPlanning/components/PlanSettingsForm/utils'
import { roofStoreyKey } from '@editorStores'

export type VerticalRoofSlabCreatePayload = ShapeObject & {
  positionPlanSettings: SlabLikePositionPlanSettings
  certificateSettings: SlabLikeCertificateSettings
}

export const createVerticalRoofSlabPayload = (
  points: Array<{ x: number; y: number; z: number }>,
): VerticalRoofSlabCreatePayload => ({
  guid: v4(),
  shape: { points: points as Point[] },
  storey: roofStoreyKey,
  element_type: 'vertical_roof_slabs',
  ...DEFAULT_SLAB_LIKE_SETTINGS,
})
